import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getPendaftarByUser = createAsyncThunk("registrasi/getByUser", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/pendaftar/get-user`);
    return response.data;
});

export const findByUserId = createAsyncThunk("registrasi/findByUserId", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/pendaftar/param/user`,val);
    return response.data;
});

const initialState = {
    loading : false,
    dataList : [],
    dataPendaftar : [],
    result:{},
    selectedData:{}
}

const pendaftaranSlice = createSlice({
    name:"pendaftaranSlice",
    initialState: initialState,
    extraReducers: {
        [getPendaftarByUser.pending] : (state, action) => {
            state.loading = true;
        },
        [getPendaftarByUser.fulfilled] : (state, action) => {
            state.dataPendaftar = action.payload;
            state.selectedData = action.payload;
            state.loading = false;
        },
        [getPendaftarByUser.pending] : (state, action) => {
            state.loading = true;
        },

        [findByUserId.pending] : (state, action) => {
            state.loading = true;
        },
        [findByUserId.fulfilled] : (state, action) => {
            state.result = action.payload;
            state.loading = false;
        },
        [findByUserId.pending] : (state, action) => {
            state.loading = true;
        },
    }
})

export const pendaftaranSelector = (state) => state.pendaftaran;
export default pendaftaranSlice.reducer;